import {
  getInvoiceCustomerDisplayName,
  getQuickBooksCustomerName,
  type InvoiceDisplayItem,
} from "@/lib/utils/crm/quickbooks-company-ref";
import type { Contact } from "@wtc/ui/lib/types/database";
import type { Companies } from "@/src/gql/graphql";

// ============================================================================
// INVOICE DISPLAY HELPERS
// ============================================================================

export function getDisplayNameForCustomer(
  customerId: string,
  company: Companies | null | undefined,
  customerName: string
): string {
  if (company) {
    // Try to get the QuickBooks customer name from the company
    const qbName = getQuickBooksCustomerName(company, customerId);
    if (qbName) return qbName;
  }
  // Fallback to the passed customerName
  return customerName;
}

export function getAllCustomerDisplayNames(
  company: Companies | null | undefined,
  qbCustomerRefs: Array<{ customerId: string; realmId?: string }>,
  customerName: string,
  contact: Contact | null | undefined
): string[] {
  if (company && qbCustomerRefs.length > 0) {
    const names = qbCustomerRefs.map((ref) => {
      const qbName = getQuickBooksCustomerName(company, ref.customerId);
      return qbName || `Customer ${ref.customerId}`;
    });
    return names;
  }
  return [customerName || company?.name || contact?.company_name || contact?.name || "Unknown"];
}

export function getInvoiceCustomerName(
  invoiceItem: InvoiceDisplayItem,
  company: Companies | null | undefined
): string {
  return getInvoiceCustomerDisplayName(invoiceItem, company);
}
